// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2Gjtr","tab":"Tabs_tab__22h65","tabActive":"Tabs_tabActive__1aBiE"};